export default __webpack_public_path__ + "static/media/Mystic's Vestment of the Eldritch.b845a263.jpg";